"use client";

import { ButtonLink, TCommonHeroSection } from "@shared/cms";
import { Subtitle } from "@shared/ui";
import { cn } from "@ubud-ui/react-ui-kit";
import Image from "next/image";

export function CommonHeroSection({
  title,
  description,
  subtitle,
  button,
  imageDesktop,
  imageMobile,
  backgroundMobile,
  direction,
}: TCommonHeroSection) {
  return (
    <section className="relative pt-14 lg:py-24">
      {imageDesktop && (
        <Image
          src={imageDesktop.url || ""}
          alt={imageDesktop.alternativeText || imageDesktop.name || ""}
          className={cn("hidden lg:block h-full absolute top-0 w-[700px] object-cover", direction === "rtl" ? "left-0" : "right-0")}
          width={imageDesktop.width || 600}
          height={imageDesktop.height || 720}
        />
      )}
      <div className="container">
        <div className={cn("relative z-10 lg:w-[34.5rem]", direction === "rtl" ? "ml-auto" : "")}>
          {subtitle && <Subtitle {...subtitle} />}
          <div className="mt-4 mb-9 sm:mb-10 mx-auto">
            <div className="mb-4 text-gray-700 text-4xl sm:text-5xl font-bold !leading-[120%]">{title}</div>
            {description && <div className="text-gray-500 text-base sm:text-lg">{description}</div>}
          </div>
          {button && <ButtonLink {...button} />}
        </div>
      </div>

      <div className="lg:hidden">
        {backgroundMobile && (
          <Image
            src={backgroundMobile.url}
            alt={backgroundMobile.alternativeText || backgroundMobile.name}
            className="absolute top-0 right-0 w-[4.5rem] sm:w-[5.6rem]"
            width={backgroundMobile.width || 62}
            height={backgroundMobile.height || 73}
          />
        )}
        {imageMobile && (
          <Image
            src={imageMobile.url}
            alt={imageMobile.alternativeText || imageMobile.name}
            className="w-full mt-6"
            width={imageMobile.width || 1000}
            height={imageMobile.height || 1000}
          />
        )}
      </div>
    </section>
  );
}
